export default "__VITE_ASSET__500591fa__"